import {
    HMPDetailsReportResponse,
    IDRPReportSchema,
    IDRPReportSchemaResponse,
    IFTFReportSchema,
    IFTFReportSchemaResponse,
    IHMPSummarySchema,
    IMBFReportSchema,
    IMBFReportSchemaResponse,
    IRemapCaseSchema,
    IRemapCaseSchemaResponse,
    IRemapInfoSessionSchema,
    IRemapInfoSessionSchemaResponse,
    IRemapParticipantSchema,
    IRemapParticipantSchemaResponse,
    ITCRReportSchema,
    ITcrReportSchemaResponse,
} from '@evencel/models';

export class HmpReportResponse {
    public static readonly type = '[Report] HmpReportResponse';
    constructor(public data: HMPDetailsReportResponse) {}
}

export class HmpSummaryReport {
    public static readonly type = '[Report] HmpSummaryReport';
    constructor(public data: IHMPSummarySchema, public center: string) {}
}

export class FtpReport {
    public static readonly type = '[Report] FtpReport';
    constructor(public data: IFTFReportSchema, public center: string) {}
}

export class FtpReportReponse {
    public static readonly type = '[Report] FtpReportReponse';
    constructor(public data: IFTFReportSchemaResponse) {}
}

export class MbfReport {
    public static readonly type = '[Report] MbfReport';
    constructor(public data: IMBFReportSchema, public center: string) {}
}

export class MbfReportReponse {
    public static readonly type = '[Report] MbfReportReponse';
    constructor(public data: IMBFReportSchemaResponse) {}
}

export class DrpReport {
    public static readonly type = '[Report] DrpReport';
    constructor(public data: IDRPReportSchema, public center: string) {}
}

export class DrpReportResponse {
    public static readonly type = '[Report] DrpReportResponse';
    constructor(public data: IDRPReportSchemaResponse[]) {}
}

export class TcrReport {
    public static readonly type = '[Report] TcrReport';
    constructor(public data: ITCRReportSchema, public center: string) {}
}

export class TcrReportReponse {
    public static readonly type = '[Report] TcrReportReponse';
    constructor(public data: ITcrReportSchemaResponse) {}
}

export class RemapParticipantReport {
    public static readonly type = '[Report] RemapParticipantReport';
    constructor(public data: IRemapParticipantSchema, public center: string) {}
}

export class RemapParticipantReportResponse {
    public static readonly type = '[Report] RemapParticipantReportResponse';
    constructor(public data: IRemapParticipantSchemaResponse[]) {}
}

export class RemapCaseReport {
    public static readonly type = '[Report] RemapCaseReport';
    constructor(public data: IRemapCaseSchema, public center: string) {}
}

export class RemapCaseReportResponse {
    public static readonly type = '[Report] RemapCaseReportResponse';
    constructor(public data: IRemapCaseSchemaResponse[]) {}
}

export class RemapInfoSessionReport {
    public static readonly type = '[Report] RemapInfoSessionReport';
    constructor(public data: IRemapInfoSessionSchema, public center: string) {}
}

export class RemapInfoSessionReportResponse {
    public static readonly type = '[Report] RemapInfoSessionReportResponse';
    constructor(public data: IRemapInfoSessionSchemaResponse[]) {}
}
